export const TABLET_BREAKPOINT = 576;
export const DESKTOP_BREAKPOINT = 992;

export const MOBILE_COLS = 2;
export const TABLET_COLS = 3;
export const DESKTOP_COLS = 5;

export const PRODUCTO_LINEA = "productoLinea";
export const PRODUCTO_ESPECIAL = "productoEspecial";

export const ROLES_PGI = ["owner", "author"];
export const ROLES_CLIENTES = ["Usuario"];

export const PDFtype = "application/pdf";
export const URLDefaultLogoTensolite = "https://tensolite.com/images/redes.png";